var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.005,
    height: 16.879,
    viewBox: "0 0 18.005 16.879",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shop",
    d: "M3.342,1.394A1.125,1.125,0,0,1,4.2,1h9.61a1.125,1.125,0,0,1,.855.394L17.6,4.819A1.688,1.688,0,0,1,18,5.917V6.2a2.673,2.673,0,0,1-4.782,1.641,2.673,2.673,0,0,1-4.22,0,2.673,2.673,0,0,1-4.22,0A2.673,2.673,0,0,1,0,6.2V5.917a1.688,1.688,0,0,1,.406-1.1L3.343,1.393Zm2,4.811a1.547,1.547,0,0,0,3.095,0,.563.563,0,1,1,1.125,0,1.547,1.547,0,0,0,3.095,0,.563.563,0,1,1,1.125,0,1.547,1.547,0,0,0,3.095,0V5.917a.563.563,0,0,0-.135-.366L13.807,2.125H4.2L1.26,5.552a.563.563,0,0,0-.135.366V6.2a1.547,1.547,0,0,0,3.095,0,.563.563,0,0,1,1.125,0ZM1.688,9.44A.563.563,0,0,1,2.251,10v6.752H3.376V11.128A1.125,1.125,0,0,1,4.5,10H7.877A1.125,1.125,0,0,1,9,11.128v5.626h6.752V10a.563.563,0,0,1,1.125,0v6.752h.563a.563.563,0,1,1,0,1.125H.563a.563.563,0,1,1,0-1.125h.563V10a.563.563,0,0,1,.563-.563ZM4.5,16.754H7.877V11.128H4.5Zm5.626-5.626A1.125,1.125,0,0,1,11.253,10H13.5a1.125,1.125,0,0,1,1.125,1.125V14.5A1.125,1.125,0,0,1,13.5,15.629H11.253A1.125,1.125,0,0,1,10.128,14.5Zm3.376,0H11.253V14.5H13.5Z",
    transform: "translate(0 -1)",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.aab154d52ae3cbd99d41df2f28a65eb7.svg";
export { ForwardRef as ReactComponent };